<div class="job__shifts" *ngIf="shift">

    <h3 class="job__hed">{{shiftTitle || 'Shifts'}}
    </h3>
    <div class="job__vizLegend">
        <div class="job__vizLabel job__vizLabel--1">4</div>
        <div class="job__vizLabel job__vizLabel--2">8</div>
        <div class="job__vizLabel job__vizLabel--3">12</div>
        <div class="job__vizLabel job__vizLabel--4">4</div>
        <div class="job__vizLabel job__vizLabel--5">8</div>
    </div>
    <app-shift-day-line *ngFor="let day of days"
                        [day]="day"
                        [shiftTimes]="shift.shiftTimes"
                        class="job__day day"></app-shift-day-line>
</div>
